import { config } from '../_config';
import { authHeader, handleResponse } from '../_helpers';

export const miscellaneousService = {
  getCountries,
};


function getCountries() {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  };

  return fetch(`${config.apiUrl}/countries`, requestOptions).then(handleResponse)
    .then(response => {
      localStorage.setItem('countries', JSON.stringify(response));
      return response
    })
}
